(() => {
  const sections = document.querySelectorAll('[data-t6-section]');
  if (!sections.length) return;

  sections.forEach((page) => {
    const $ = (selector) => page.querySelector(selector);
    const $$ = (selector) => Array.from(page.querySelectorAll(selector));
    const copies = {de: {
      announcementPrefix: "Hinweis ",
      announcementOf: " von ",
      announcementStart: "Automatische Wiedergabe starten",
      announcementStop: "Automatische Wiedergabe anhalten",
      menuOpen: "Menü öffnen",
      menuClose: "Menü schließen",
      reviewTranslate: "Ins Deutsche übersetzen",
      reviewTranslating: "Wird übersetzt…",
      reviewOriginal: "Original anzeigen",
      reviewOriginalShown: "Der Originaltext wird angezeigt.",
      reviewTranslationShown: "Die deutsche Übersetzung wird angezeigt.",
      checkoutDefault: "Nachnahme · Kostenloser Versand",
      previewLocked: "Vorschau · Bestellungen noch nicht möglich",
      available: "Bestellbar",
      soldOut: "Ausverkauft",
      checkoutPreparing: "Checkout wird vorbereitet…",
      checkoutError: "Der Checkout konnte nicht geöffnet werden. Bitte versuchen Sie es erneut."
    }, ro: {
      announcementPrefix: "Anunțul ",
      announcementOf: " din ",
      announcementStart: "Pornește redarea automată",
      announcementStop: "Oprește redarea automată",
      menuOpen: "Deschide meniul",
      menuClose: "Închide meniul",
      reviewTranslate: "Tradu în română",
      reviewTranslating: "Se traduce…",
      reviewOriginal: "Arată originalul",
      reviewOriginalShown: "Textul original este afișat.",
      reviewTranslationShown: "Traducerea în română este afișată.",
      checkoutDefault: "Plată la livrare · Transport gratuit",
      previewLocked: "Previzualizare · comenzile nu sunt deschise",
      available: "Disponibil pentru comandă",
      soldOut: "Stoc epuizat",
      checkoutPreparing: "Se pregătește checkout-ul…",
      checkoutError: "Nu am putut deschide checkout-ul. Încearcă din nou."
    }, 'pt-PT': {
      announcementPrefix: 'Aviso ', announcementOf: ' de ', announcementStart: 'Iniciar reprodução automática', announcementStop: 'Parar reprodução automática',
      menuOpen: 'Abrir menu', menuClose: 'Fechar menu', reviewTranslate: 'Traduzir para português', reviewTranslating: 'A traduzir…', reviewOriginal: 'Mostrar original',
      reviewOriginalShown: 'O texto original está visível.', reviewTranslationShown: 'A tradução em português está visível.',
      checkoutDefault: 'Pagamento na entrega · Entrega gratuita', previewLocked: 'Pré-visualização · encomendas ainda indisponíveis', available: 'Disponível para encomenda', soldOut: 'Esgotado',
      checkoutPreparing: 'A preparar a finalização da compra…', checkoutError: 'Não foi possível abrir a finalização da compra. Tente novamente.', marketError: 'O preço não corresponde ao país selecionado. Selecione novamente o país no menu.'
    }, hr: {
      announcementPrefix: 'Obavijest ', announcementOf: ' od ', announcementStart: 'Pokreni automatsku reprodukciju', announcementStop: 'Zaustavi automatsku reprodukciju',
      menuOpen: 'Otvori izbornik', menuClose: 'Zatvori izbornik', reviewTranslate: 'Prevedi na hrvatski', reviewTranslating: 'Prevođenje…', reviewOriginal: 'Prikaži izvornik',
      reviewOriginalShown: 'Prikazan je izvorni tekst.', reviewTranslationShown: 'Prikazan je prijevod na hrvatski.',
      checkoutDefault: 'Plaćanje pouzećem · Besplatna dostava', previewLocked: 'Pretpregled · naručivanje još nije dostupno', available: 'Dostupno za narudžbu', soldOut: 'Rasprodano',
      checkoutPreparing: 'Priprema naplate…', checkoutError: 'Nije moguće otvoriti naplatu. Pokušajte ponovno.', marketError: 'Cijena ne odgovara odabranoj državi. Ponovno odaberite državu u izborniku.'
    }, hu: {
      announcementPrefix: 'Közlemény ', announcementOf: ' / ', announcementStart: 'Automatikus lejátszás indítása', announcementStop: 'Automatikus lejátszás leállítása',
      menuOpen: 'Menü megnyitása', menuClose: 'Menü bezárása', reviewTranslate: 'Fordítás magyarra', reviewTranslating: 'Fordítás folyamatban…', reviewOriginal: 'Eredeti megjelenítése',
      reviewOriginalShown: 'Az eredeti szöveg látható.', reviewTranslationShown: 'A magyar fordítás látható.',
      checkoutDefault: 'Utánvétes fizetés · Ingyenes szállítás', previewLocked: 'Előnézet · rendelés még nem lehetséges', available: 'Rendelhető', soldOut: 'Elfogyott',
      checkoutPreparing: 'A pénztár előkészítése…', checkoutError: 'Nem sikerült megnyitni a pénztárt. Próbálja újra.', marketError: 'Az ár nem egyezik a kiválasztott országgal. Válassza ki újra az országot a menüben.'
    }, pl: {
      announcementPrefix: 'Komunikat ', announcementOf: ' z ', announcementStart: 'Uruchom automatyczne odtwarzanie', announcementStop: 'Zatrzymaj automatyczne odtwarzanie',
      menuOpen: 'Otwórz menu', menuClose: 'Zamknij menu', reviewTranslate: 'Przetłumacz na polski', reviewTranslating: 'Tłumaczenie…', reviewOriginal: 'Pokaż oryginał',
      reviewOriginalShown: 'Wyświetlany jest oryginalny tekst.', reviewTranslationShown: 'Wyświetlane jest polskie tłumaczenie.',
      checkoutDefault: 'Kup teraz', previewLocked: 'Podgląd · zamówienia nie są jeszcze dostępne', available: 'Dostępny do zamówienia', soldOut: 'Wyprzedany',
      checkoutPreparing: 'Przygotowywanie płatności…', checkoutError: 'Nie udało się otworzyć strony płatności. Spróbuj ponownie.', marketError: 'Cena nie odpowiada wybranemu krajowi. Wybierz kraj ponownie w menu.'
    }, cs: {
      announcementPrefix: 'Oznámení ', announcementOf: ' z ', announcementStart: 'Spustit automatické přehrávání', announcementStop: 'Zastavit automatické přehrávání',
      menuOpen: 'Otevřít nabídku', menuClose: 'Zavřít nabídku', reviewTranslate: 'Přeložit do češtiny', reviewTranslating: 'Překládá se…', reviewOriginal: 'Zobrazit originál',
      reviewOriginalShown: 'Je zobrazen původní text.', reviewTranslationShown: 'Je zobrazen český překlad.',
      checkoutDefault: 'Platba na dobírku · Doprava zdarma', previewLocked: 'Náhled · objednávky zatím nejsou dostupné', available: 'Lze objednat', soldOut: 'Vyprodáno',
      checkoutPreparing: 'Připravuje se pokladna…', checkoutError: 'Pokladnu se nepodařilo otevřít. Zkuste to znovu.', marketError: 'Cena neodpovídá vybrané zemi. Vyberte zemi znovu v nabídce.'
    }};
    copies.de.marketError = 'Der Preis passt nicht zum ausgewählten Land. Wählen Sie das Land im Menü erneut aus.';
    copies.ro.marketError = 'Prețul nu corespunde țării selectate. Selectează din nou țara din meniu.';
    const copy = copies[page.lang] || copies.ro;
    // Country is never inferred from language: AT and DE remain distinct destinations.
    const approvedMarkets = {
      DE: { language: 'DE', currency: 'EUR', basic: 89, full: 109 },
      AT: { language: 'DE', currency: 'EUR', basic: 89, full: 109 },
      PT: { language: 'PT_PT', currency: 'EUR', basic: 69, full: 89 },
      HR: { language: 'HR', currency: 'EUR', basic: 69, full: 89 },
      HU: { language: 'HU', currency: 'HUF', basic: 25500, full: 33000 },
      CZ: { language: 'CS', currency: 'CZK', basic: 1700, full: 2200 },
      RO: { language: 'RO', currency: 'RON', basic: 370, full: 450 },
      PL: { language: 'PL', currency: 'PLN', contextualPrice: true }
    };
    const market = approvedMarkets[page.dataset.marketCountry];
    const marketPicker = $('[data-t6-market-picker]');
    const marketTrigger = $('[data-t6-market-trigger]');
    const marketMenu = $('[data-t6-market-menu]');
    const marketOptions = marketMenu ? Array.from(marketMenu.querySelectorAll('[data-t6-market-option]')) : [];
    const marketDesktop = window.matchMedia('(min-width:1068px) and (hover:hover) and (pointer:fine)');
    function closeMarketMenu(restoreFocus = false) {
      if (!marketMenu || !marketTrigger) return;
      marketMenu.hidden = true;
      marketTrigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) marketTrigger.focus();
    }
    marketDesktop.addEventListener('change', () => { if (!marketDesktop.matches) closeMarketMenu(); });
    function openMarketMenu(focusOption = false) {
      if (!marketDesktop.matches || !marketMenu || !marketTrigger) return;
      marketMenu.hidden = false;
      marketTrigger.setAttribute('aria-expanded', 'true');
      if (focusOption) (marketOptions.find((option) => option.getAttribute('aria-checked') === 'true') || marketOptions[0])?.focus();
    }
    marketTrigger?.addEventListener('click', () => {
      if (marketMenu.hidden) openMarketMenu();
      else closeMarketMenu();
    });
    marketPicker?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !marketMenu.hidden) {
        event.preventDefault();
        closeMarketMenu(true);
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (document.activeElement === marketTrigger) {
          event.preventDefault();
          openMarketMenu(true);
        } else if (!marketMenu.hidden && marketOptions.includes(document.activeElement)) {
          event.preventDefault();
          const index = marketOptions.indexOf(document.activeElement);
          marketOptions[(index + (event.key === 'ArrowDown' ? 1 : -1) + marketOptions.length) % marketOptions.length]?.focus();
        }
      }
    });
    document.addEventListener('click', (event) => {
      if (marketPicker && !marketPicker.contains(event.target)) closeMarketMenu();
    });
    const announcement = $('[data-t6-announcement]');
    const announcementSlides = announcement ? Array.from(announcement.querySelectorAll('[data-t6-announcement-slide]')) : [];
    if (announcement && announcementSlides.length > 1) {
      const announcementStatus = announcement.querySelector('[data-t6-announcement-status]');
      const pauseButton = announcement.querySelector('[data-t6-announcement-pause]');
      const reducedAnnouncementMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let announcementIndex = 0;
      let announcementTimer = null;
      let announcementPaused = false;
      function showAnnouncement(index, manual = false) {
        announcementIndex = (index + announcementSlides.length) % announcementSlides.length;
        announcementSlides.forEach((slide, i) => {
          const active = i === announcementIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.tabIndex = active ? 0 : -1;
        });
        if (manual && announcementStatus) {
          announcementStatus.textContent = copy.announcementPrefix + (announcementIndex + 1) + copy.announcementOf + announcementSlides.length + ': ' + announcementSlides[announcementIndex].textContent.trim();
        }
      }
      function stopAnnouncement() {
        if (announcementTimer !== null) window.clearInterval(announcementTimer);
        announcementTimer = null;
      }
      function startAnnouncement() {
        stopAnnouncement();
        if (announcementPaused || reducedAnnouncementMotion || document.hidden || announcement.matches(':hover') || announcement.contains(document.activeElement)) return;
        announcementTimer = window.setInterval(() => showAnnouncement(announcementIndex + 1), 5000);
      }
      function manualAnnouncement(direction) {
        showAnnouncement(announcementIndex + direction, true);
        startAnnouncement();
      }
      announcement.querySelector('[data-t6-announcement-prev]')?.addEventListener('click', () => manualAnnouncement(-1));
      announcement.querySelector('[data-t6-announcement-next]')?.addEventListener('click', () => manualAnnouncement(1));
      announcement.addEventListener('mouseenter', stopAnnouncement);
      announcement.addEventListener('mouseleave', startAnnouncement);
      announcement.addEventListener('focusin', stopAnnouncement);
      announcement.addEventListener('focusout', (event) => {
        if (!announcement.contains(event.relatedTarget)) startAnnouncement();
      });
      document.addEventListener('visibilitychange', startAnnouncement);
      pauseButton?.addEventListener('click', () => {
        announcementPaused = !announcementPaused;
        pauseButton.textContent = announcementPaused ? copy.announcementStart : copy.announcementStop;
        pauseButton.setAttribute('aria-label', pauseButton.textContent);
        if (announcementPaused) stopAnnouncement();
        else startAnnouncement();
      });
      showAnnouncement(0);
      startAnnouncement();
    }

    const highlights = $('[data-t6-highlights]');
    if (highlights) {
      const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function updateHighlightsPosition() {
        const end = Math.max(0, highlights.scrollWidth - highlights.clientWidth);
        const startVisible = end > 2 && highlights.scrollLeft <= 2;
        const endVisible = end > 2 && highlights.scrollLeft >= end - 2;
        highlights.classList.toggle('is-at-start', startVisible);
        highlights.classList.toggle('is-at-end', endVisible);
        highlights.classList.toggle('is-in-middle', end > 2 && !startVisible && !endVisible);
      }
      highlights.addEventListener('mouseenter', () => {
        if (hoverPointer.matches && highlights.scrollWidth > highlights.clientWidth) {
          highlights.scrollTo({ left: highlights.scrollWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      });
      highlights.addEventListener('mouseleave', () => {
        if (hoverPointer.matches) highlights.scrollTo({ left: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
      highlights.addEventListener('scroll', updateHighlightsPosition, { passive: true });
      window.addEventListener('resize', updateHighlightsPosition);
      updateHighlightsPosition();
    }

    const gallery = $('[data-t6-gallery]');
    const slides = $$('[data-t6-slide]');
    const thumbs = $$('[data-t6-thumb]');
    const counter = $('[data-t6-gallery-count]');
    const lightbox = $('[data-t6-lightbox]');
    const lightboxImage = $('[data-t6-lightbox-image]');
    const lightboxCounter = $('[data-t6-lightbox-count]');
    let galleryIndex = 0;
    let lightboxReturnFocus = null;

    function showGallery(index) {
      if (!slides.length) return;
      galleryIndex = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === galleryIndex);
        slide.setAttribute('aria-hidden', i === galleryIndex ? 'false' : 'true');
        const video = slide.querySelector('video');
        if (video && i !== galleryIndex) video.pause();
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === galleryIndex);
        thumb.setAttribute('aria-pressed', i === galleryIndex ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(galleryIndex + 1) + ' / ' + String(slides.length);
      if (lightboxCounter) lightboxCounter.textContent = String(galleryIndex + 1) + ' / ' + String(slides.length);
      [$('[data-t6-gallery-prev]'), $('[data-t6-lightbox-prev]')].forEach((button) => {
        if (button) button.disabled = galleryIndex === 0;
      });
      [$('[data-t6-gallery-next]'), $('[data-t6-lightbox-next]')].forEach((button) => {
        if (button) button.disabled = galleryIndex === slides.length - 1;
      });
      const thumbScroller = $('[data-t6-thumbs]');
      if (window.innerWidth <= 680 && thumbScroller && thumbs[galleryIndex]) {
        thumbScroller.scrollTo({ left: thumbs[galleryIndex].offsetLeft - thumbScroller.offsetLeft - 16, behavior: 'smooth' });
      }
      if (lightbox?.open && lightboxImage) {
        const image = slides[galleryIndex].querySelector('img') || thumbs[galleryIndex]?.querySelector('img');
        if (image) {
          lightboxImage.src = image.src || image.currentSrc;
          lightboxImage.alt = image.alt || 'TITAN T6';
        }
      }
    }

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showGallery(i)));
    $('[data-t6-gallery-prev]')?.addEventListener('click', () => showGallery(galleryIndex - 1));
    $('[data-t6-gallery-next]')?.addEventListener('click', () => showGallery(galleryIndex + 1));
    $('[data-t6-lightbox-prev]')?.addEventListener('click', () => showGallery(galleryIndex - 1));
    $('[data-t6-lightbox-next]')?.addEventListener('click', () => showGallery(galleryIndex + 1));
    function openLightbox() {
      const image = slides[galleryIndex]?.querySelector('img') || thumbs[galleryIndex]?.querySelector('img');
      if (!image || !lightbox || !lightboxImage) return;
      lightboxReturnFocus = document.activeElement;
      lightboxImage.src = image.src || image.currentSrc;
      lightboxImage.alt = image.alt || 'TITAN T6';
      lightbox.showModal();
      $('[data-t6-lightbox-close]')?.focus();
    }
    $('[data-t6-gallery-expand]')?.addEventListener('click', openLightbox);
    $$('[data-t6-open-zoom]').forEach((trigger) => {
      trigger.addEventListener('click', openLightbox);
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openLightbox();
        }
      });
    });
    $('[data-t6-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox?.addEventListener('close', () => lightboxReturnFocus?.focus());
    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showGallery(galleryIndex - 1);
      if (event.key === 'ArrowRight') showGallery(galleryIndex + 1);
    });
    if (lightbox) {
      let lightboxPointerStart = null;
      lightbox.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.pointerType === 'pen') lightboxPointerStart = event.clientX;
      });
      lightbox.addEventListener('pointerup', (event) => {
        if (lightboxPointerStart === null) return;
        const delta = event.clientX - lightboxPointerStart;
        lightboxPointerStart = null;
        if (Math.abs(delta) > 45) showGallery(galleryIndex + (delta < 0 ? 1 : -1));
      });
      lightbox.addEventListener('pointercancel', () => { lightboxPointerStart = null; });
    }

    if (gallery) {
      let pointerStart = null;
      gallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.pointerType === 'pen') pointerStart = event.clientX;
      });
      gallery.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const delta = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(delta) > 45) showGallery(galleryIndex + (delta < 0 ? 1 : -1));
      });
      gallery.addEventListener('pointercancel', () => { pointerStart = null; });
    }
    showGallery(0);

    const menuToggle = $('[data-t6-menu-toggle]');
    const nav = $('[data-t6-nav]');
    menuToggle?.addEventListener('click', () => {
      const open = nav?.classList.toggle('is-open') || false;
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.setAttribute('aria-label', open ? copy.menuClose : copy.menuOpen);
    });
    nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      nav.classList.remove('is-open');
      menuToggle?.setAttribute('aria-expanded', 'false');
      menuToggle?.setAttribute('aria-label', copy.menuOpen);
    }));
    const bottomSheet = $('[data-t6-bottom-sheet]');
    $('[data-t6-bottom-menu-open]')?.addEventListener('click', () => bottomSheet?.showModal());
    $('[data-t6-bottom-menu-close]')?.addEventListener('click', () => bottomSheet?.close());
    bottomSheet?.addEventListener('click', (event) => {
      if (event.target === bottomSheet) bottomSheet.close();
    });

    const footerColumns = $$('[data-t6-footer-column]');
    const mobileFooter = window.matchMedia('(max-width: 767px)');
    const syncFooterColumns = () => footerColumns.forEach((column) => { column.open = !mobileFooter.matches; });
    footerColumns.forEach((column) => column.querySelector('summary')?.addEventListener('click', (event) => {
      if (!mobileFooter.matches) event.preventDefault();
    }));
    syncFooterColumns();
    if (mobileFooter.addEventListener) mobileFooter.addEventListener('change', syncFooterColumns);
    else mobileFooter.addListener(syncFooterColumns);

    const sectionIds = ['t6-overview', 't6-highlights', 't6-features', 't6-specs', 't6-faq', 't6-reviews'];
    if (window.location.hash === '#t6-faq-warranty') $('#t6-faq-warranty')?.setAttribute('open', '');
    const navLinks = $$('a[href^="#t6-"]');
    navLinks.forEach((link) => link.addEventListener('click', (event) => {
      const id = link.getAttribute('href')?.slice(1);
      const target = id ? $('#' + id) : null;
      if (!target) return;
      event.preventDefault();
      if (target.tagName === 'DETAILS') target.open = true;
      bottomSheet?.close();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (window.history.replaceState) window.history.replaceState({}, '', '#' + id);
      setActiveLink(id);
    }));
    function setActiveLink(id) {
      navLinks.forEach((link) => {
        const current = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-current', current);
        if (current) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    const initialSection = window.location.hash.slice(1);
    if (sectionIds.includes(initialSection)) setActiveLink(initialSection);
    if ('IntersectionObserver' in window) {
      const navObserver = new IntersectionObserver((entries) => {
        const intersecting = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (intersecting[0]) setActiveLink(intersecting[0].target.id);
      }, { rootMargin: '-12% 0px -82% 0px', threshold: [0, 0.25, 0.5] });
      sectionIds.forEach((id) => {
        const target = $('#' + id);
        if (target) navObserver.observe(target);
      });
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion && 'IntersectionObserver' in window) {
      $$('[data-t6-word-reveal]').forEach((heading) => {
        const words = heading.textContent.trim().split(/\s+/);
        heading.setAttribute('aria-label', heading.textContent.trim());
        heading.textContent = '';
        heading.classList.add('t6-word-ready');
        words.forEach((word, index) => {
          const span = document.createElement('span');
          span.textContent = word + (index === words.length - 1 ? '' : '\u00a0');
          span.setAttribute('aria-hidden', 'true');
          span.style.setProperty('--word-index', String(index));
          heading.appendChild(span);
        });
      });
    }
    const pageWrapper = document.querySelector('.page-wrapper');
    const wrapperScrolls = !!pageWrapper && ['auto', 'scroll'].includes(window.getComputedStyle(pageWrapper).overflowY);
    const scrollTarget = wrapperScrolls ? pageWrapper : window;
    const scrollPosition = () => wrapperScrolls ? pageWrapper.scrollTop : window.scrollY;
    const revealTargets = $$('[data-t6-reveal]');
    if (revealTargets.length && 'IntersectionObserver' in window && !reduceMotion) {
      page.classList.add('t6-reveal-ready');
      function showReveal(target) {
        if (target.classList.contains('is-visible')) return;
        target.classList.add('is-visible');
        target.querySelectorAll('[data-t6-word-reveal]').forEach((heading) => heading.classList.add('is-visible'));
        revealObserver.unobserve(target);
      }
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) showReveal(entry.target);
        });
      }, { root: wrapperScrolls ? pageWrapper : null, rootMargin: '0px 0px 30% 0px', threshold: 0 });
      revealTargets.forEach((target) => revealObserver.observe(target));
      function revealNearViewport() {
        const viewportBottom = wrapperScrolls ? pageWrapper.getBoundingClientRect().bottom : window.innerHeight;
        const lead = (wrapperScrolls ? pageWrapper.clientHeight : window.innerHeight) * 0.3;
        revealTargets.forEach((target) => {
          if (!target.classList.contains('is-visible') && target.getBoundingClientRect().top <= viewportBottom + lead) showReveal(target);
        });
      }
      let revealFrame = null;
      scrollTarget.addEventListener('scroll', () => {
        if (revealFrame !== null) return;
        revealFrame = window.requestAnimationFrame(() => { revealFrame = null; revealNearViewport(); });
      }, { passive: true });
      revealNearViewport();
    }

    const header = $('.t6-header');
    let lastScrollY = scrollPosition();
    page.classList.add('t6-header-visible');
    function updateHeader() {
      const currentY = scrollPosition();
      const change = currentY - lastScrollY;
      if (currentY < 90 || change < -6) {
        header?.classList.remove('is-hidden');
        page.classList.add('t6-header-visible');
      } else if (currentY > 160 && change > 6 && !nav?.classList.contains('is-open')) {
        header?.classList.add('is-hidden');
        page.classList.remove('t6-header-visible');
      }
      header?.classList.toggle('is-scrolled', currentY > 20);
      lastScrollY = currentY;
    }
    scrollTarget.addEventListener('scroll', updateHeader, { passive: true });

    if (!reduceMotion && !window.matchMedia('(pointer: coarse)').matches) {
      const collage = $('.t6-collage');
      const parallaxLeft = $('[data-t6-parallax="left"]');
      const parallaxRight = $('[data-t6-parallax="right"]');
      const marquees = $$('[data-t6-marquee]');
      let motionFrame = null;
      function updateScrollMotion() {
        motionFrame = null;
        if (collage) {
          const rect = collage.getBoundingClientRect();
          if (window.matchMedia('(max-width: 680px)').matches) {
            if (parallaxLeft) parallaxLeft.style.transform = '';
            if (parallaxRight) parallaxRight.style.transform = '';
          } else {
            const viewport = wrapperScrolls ? pageWrapper.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };
            if (rect.bottom > viewport.top - 100 && rect.top < viewport.bottom + 100) {
              const viewportHeight = viewport.bottom - viewport.top;
              const progress = Math.max(0, Math.min(1, (viewport.bottom - rect.top) / (viewportHeight + rect.height)));
              if (parallaxLeft) parallaxLeft.style.transform = 'translate3d(0,' + Math.round((.5 - progress) * 24) + 'px,0)';
              if (parallaxRight) parallaxRight.style.transform = 'translate3d(0,' + Math.round((progress - .5) * 12) + 'px,0)';
            }
          }
        }
        marquees.forEach((marquee) => {
          const rect = marquee.getBoundingClientRect();
          if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;
          const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
          marquee.style.setProperty('--t6-scroll-x', String(Math.round(-80 * progress)) + 'px');
        });
      }
      function scheduleScrollMotion() {
        if (motionFrame === null) motionFrame = window.requestAnimationFrame(updateScrollMotion);
      }
      scrollTarget.addEventListener('scroll', scheduleScrollMotion, { passive: true });
      window.addEventListener('resize', scheduleScrollMotion, { passive: true });
      scheduleScrollMotion();
    }

    const specAccordions = $$('.t6-specs .t6-accordion');
    specAccordions.forEach((details) => details.addEventListener('toggle', () => {
      if (details.open) specAccordions.forEach((other) => { if (other !== details) other.open = false; });
    }));

    $$('[data-t6-review]').forEach((review) => {
      const original = review.querySelector('[data-t6-review-original]');
      const translation = review.querySelector('[data-t6-review-translation], [data-t6-review-ro]');
      const button = review.querySelector('[data-t6-review-translate]');
      const label = review.querySelector('[data-t6-review-label]');
      const spinner = review.querySelector('[data-t6-review-spinner]');
      const status = review.querySelector('[data-t6-review-status]');
      if (!original || !translation || !button || !label || !spinner) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        if (button.disabled) return;
        if (!translation.hidden) {
          translation.hidden = true;
          original.hidden = false;
          label.textContent = copy.reviewTranslate;
          button.setAttribute('aria-pressed', 'false');
          if (status) status.textContent = copy.reviewOriginalShown;
          return;
        }
        button.disabled = true;
        review.setAttribute('aria-busy', 'true');
        spinner.hidden = false;
        label.textContent = copy.reviewTranslating;
        window.setTimeout(() => {
          original.hidden = true;
          translation.hidden = false;
          spinner.hidden = true;
          label.textContent = copy.reviewOriginal;
          button.setAttribute('aria-pressed', 'true');
          button.disabled = false;
          review.removeAttribute('aria-busy');
          if (status) status.textContent = copy.reviewTranslationShown;
        }, 2000);
      });
    });

    $$('[data-t6-package-viewer]').forEach((viewer) => {
      const viewButtons = Array.from(viewer.querySelectorAll('[data-t6-package-view]'));
      const viewName = viewer.querySelector('[data-t6-package-view-name]');
      const viewExtras = Array.from(viewer.querySelectorAll('[data-t6-package-extra]'));
      const viewBatteries = Array.from(viewer.querySelectorAll('[data-t6-package-battery]'));

      function showPackageContents(packageKind) {
        const isBasic = packageKind === 'basic';
        viewer.dataset.t6PackageViewState = isBasic ? 'basic' : 'full';
        viewButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.t6PackageView === packageKind));
        });
        if (viewName) viewName.textContent = isBasic ? viewName.dataset.basicLabel : viewName.dataset.fullLabel;
        viewExtras.forEach((item) => { item.hidden = isBasic; });
        viewBatteries.forEach((label) => { label.textContent = isBasic ? label.dataset.basicLabel : label.dataset.fullLabel; });
      }

      showPackageContents('full');
      viewButtons.forEach((button) => button.addEventListener('click', () => {
        showPackageContents(button.dataset.t6PackageView);
      }));
    });

    const variantField = $('[data-t6-variant]');
    const packageChoices = $$('[data-t6-package-choice]');
    const offerCards = $$('[data-t6-offer]');
    const packageNames = $$('[data-t6-package-name]');
    const quantityField = $('[data-t6-quantity]');
    const stickyButton = $('[data-t6-sticky-add]');
    const checkoutButton = $('[data-t6-checkout]');
    const checkoutDefaultLabel = checkoutButton?.textContent || copy.checkoutDefault;
    let checkoutPending = false;
    const errorBox = $('[data-t6-checkout-error]');
    const money = $('[data-t6-price]');
    const compareMoney = $('[data-t6-compare-price]');
    const stickyMoney = $('[data-t6-sticky-price]');
    const availability = $('[data-t6-availability]');
    const previewLocked = page.dataset.previewLocked === 'true' || page.dataset.twoTiersPreview === 'true';

    function selectedVariant() {
      return variantField?.tagName === 'SELECT' ? variantField.selectedOptions[0] : variantField;
    }
    function quantity() { return 1; }
    function priceMatchesMarket(selected) {
      if (!market || page.dataset.marketCurrency !== market.currency || !selected?.dataset.package) return false;
      // Poland uses Shopify's contextual PLN price. No fixed conversion or guessed price.
      if (market.contextualPrice) return Number.isFinite(Number(selected.dataset.priceAmount)) && Number(selected.dataset.priceAmount) > 0;
      return Math.abs(Number(selected.dataset.priceAmount) - market[selected.dataset.package]) < 0.001;
    }
    if (quantityField) quantityField.value = '1';
    function updateVariant(syncUrl = false) {
      const selected = selectedVariant();
      if (!selected) return;
      const available = selected.dataset.available === 'true';
      const marketValid = priceMatchesMarket(selected);
      const canCheckout = !previewLocked && available && marketValid && selected.dataset.virtual !== 'true' && /^gid:\/\/shopify\/ProductVariant\/\d+$/.test(selected.dataset.gid || '') && page.dataset.checkoutEnabled === 'true' && !checkoutPending;
      if (errorBox && !checkoutPending) {
        errorBox.hidden = marketValid;
        errorBox.textContent = marketValid ? '' : copy.marketError;
      }
      const selectedPackage = selected.dataset.package;
      if (money) money.textContent = selected.dataset.price || '';
      if (stickyMoney) stickyMoney.textContent = selected.dataset.price || '';
      if (compareMoney) {
        compareMoney.textContent = selected.dataset.comparePrice || '';
        compareMoney.hidden = !selected.dataset.comparePrice;
      }
      if (availability) availability.textContent = previewLocked ? copy.previewLocked : (available ? copy.available : copy.soldOut);
      if (selectedPackage) {
        packageChoices.forEach((choice) => {
          choice.checked = choice.value === selectedPackage;
          choice.disabled = checkoutPending;
        });
        offerCards.forEach((card) => card.classList.toggle('is-selected', card.dataset.t6Offer === selectedPackage));
        packageNames.forEach((label) => { label.textContent = selected.dataset.packageName || ''; });
      }
      if (stickyButton) {
        stickyButton.disabled = !canCheckout;
        stickyButton.textContent = checkoutDefaultLabel;
      }
      if (checkoutButton) checkoutButton.disabled = !canCheckout;
      if (selected.dataset.mediaId) {
        const matchingIndex = slides.findIndex((slide) => slide.dataset.mediaId === selected.dataset.mediaId);
        if (matchingIndex >= 0) showGallery(matchingIndex);
      }
      if (syncUrl && variantField?.tagName === 'SELECT' && window.history.replaceState) {
        const url = new URL(window.location.href);
        if (selected.dataset.virtual === 'true') url.searchParams.delete('variant');
        else url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
    packageChoices.forEach((choice) => choice.addEventListener('change', () => {
      if (!choice.checked || checkoutPending || variantField?.tagName !== 'SELECT') return;
      const option = Array.from(variantField.options).find((item) => item.dataset.package === choice.value);
      if (!option) return;
      variantField.selectedIndex = option.index;
      updateVariant(true);
    }));
    variantField?.addEventListener('change', () => updateVariant(true));
    if (packageChoices.length && variantField?.tagName === 'SELECT') {
      const explicitVariant = new URL(window.location.href).searchParams.get('variant');
      const requestedOption = explicitVariant ? Array.from(variantField.options).find((option) => option.value === explicitVariant && option.dataset.virtual !== 'true') : null;
      const basicOption = Array.from(variantField.options).find((option) => option.dataset.package === 'basic' && option.dataset.available === 'true');
      if (requestedOption) variantField.selectedIndex = requestedOption.index;
      else if (!explicitVariant && basicOption) variantField.selectedIndex = basicOption.index;
    }
    updateVariant();
    $('[data-t6-quantity-minus]')?.addEventListener('click', () => {
      if (quantityField) quantityField.value = String(Math.max(1, quantity() - 1));
    });
    $('[data-t6-quantity-plus]')?.addEventListener('click', () => {
      if (quantityField) quantityField.value = '1';
    });
    quantityField?.addEventListener('change', () => { quantityField.value = String(quantity()); });
    stickyButton?.addEventListener('click', () => checkoutButton?.click());

    const stickyPurchase = $('[data-t6-sticky-purchase]');
    const hero = $('#t6-overview');
    const footer = $('.t6-footer');
    let footerIsVisible = false;
    if (stickyPurchase && hero && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          stickyPurchase.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0 || footerIsVisible;
        });
      }, { threshold: 0 });
      stickyObserver.observe(hero);
      if (footer) {
        const footerObserver = new IntersectionObserver((entries) => {
          footerIsVisible = entries[0]?.isIntersecting || false;
          if (footerIsVisible) stickyPurchase.hidden = true;
          else if (hero.getBoundingClientRect().bottom < 0) stickyPurchase.hidden = false;
        }, { threshold: 0 });
        footerObserver.observe(footer);
      }
    }

    checkoutButton?.addEventListener('click', async () => {
      const selected = selectedVariant();
      const version = page.dataset.apiVersion || '2026-07';
      if (previewLocked || !priceMatchesMarket(selected) || page.dataset.checkoutEnabled !== 'true' || selected?.dataset.virtual === 'true' || selected?.dataset.available !== 'true' || !/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(selected?.dataset.gid || '') || checkoutButton.disabled || checkoutPending) return;
      checkoutPending = true;
      updateVariant();
      checkoutButton.textContent = copy.checkoutPreparing;
      if (stickyButton) stickyButton.textContent = copy.checkoutPreparing;
      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }
      try {
        const checkoutCountry = page.dataset.marketCountry;
        const mutation = `mutation CreateT6Cart($input: CartInput!) @inContext(country: ${checkoutCountry}, language: ${market.language}) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity cost { subtotalAmount { amount currencyCode } } lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } } } pageInfo { hasNextPage } } } userErrors { message } warnings { message } } }`;
        const response = await fetch('/api/' + encodeURIComponent(version) + '/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: mutation,
            variables: {
              input: {
                buyerIdentity: { countryCode: checkoutCountry },
                attributes: [{ key: 'expected_delivery_country', value: checkoutCountry }],
                lines: [{ merchandiseId: selected.dataset.gid, quantity: quantity() }]
              }
            }
          })
        });
        const result = await response.json();
        const created = result?.data?.cartCreate;
        const createdCart = created?.cart;
        const checkoutUrl = createdCart?.checkoutUrl;
        const returnedLines = createdCart?.lines?.nodes;
        const exactSingleItem = createdCart?.totalQuantity === 1 && returnedLines?.length === 1 &&
          createdCart.lines.pageInfo?.hasNextPage === false && returnedLines[0].quantity === 1 &&
          returnedLines[0].merchandise?.id === selected.dataset.gid;
        const subtotal = createdCart?.cost?.subtotalAmount;
        const expectedPrice = market.contextualPrice ? Number(selected.dataset.priceAmount) : market[selected.dataset.package];
        const exactPrice = subtotal?.currencyCode === market.currency && Number.isFinite(expectedPrice) && expectedPrice > 0 && Math.abs(Number(subtotal?.amount) - expectedPrice) < 0.001;
        if (!response.ok || result?.errors?.length || created?.userErrors?.length || created?.warnings?.length || !checkoutUrl || !exactSingleItem || !exactPrice) {
          throw new Error(copy.checkoutError);
        }
        window.location.assign(checkoutUrl);
      } catch (_error) {
        checkoutPending = false;
        updateVariant();
        if (errorBox) {
          errorBox.textContent = copy.checkoutError;
          errorBox.hidden = false;
        }
        checkoutButton.textContent = checkoutDefaultLabel;
      }
    });
  });
})();
